import React, { useEffect } from "react";
import { logout } from "utils/functions";
import { Fonts } from "theme/fontConfig";

export const CheckValidUser = () => {
  useEffect(() => {
    if (
      localStorage.getItem("donationLogout") &&
      localStorage.getItem("donationLogout") === "true"
    ) {
      logout();
      localStorage.removeItem("donationLogout");
      return;
    }
    setTimeout(() => {
      logout();
    }, [5000]);
  });

  return (
    <>
      {localStorage.getItem("donationLogout") &&
      localStorage.getItem("donationLogout") === "true" ? null : (
        <div
          style={{
            position: "fixed",
            background: "azure",
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
            zIndex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: Fonts.GeneralPageHeaderFont.fontSize,
          }}
        >
          {`You are not allowed to access this area`}
        </div>
      )}
    </>
  );
};
